/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any) => ({
  // 찜하기 생성
  async store(data?: any) {
    return camelize(await $axios.post(`/like`, snakelize(data)))
  },

  // Get brand liked influencers
  async brandLikedInfluencers(params?: any) {
    return camelize(await $axios.get(`/like/brand-liked-influencers`, { params: snakelize(params) }))
  },

})
